<template>
  <div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="data"
      :loading="loading"
      hide-default-footer
      :items-per-page="24"
      class="elevation-1 text-overflow my-10"
      show-select
      item-key="uuid"
      @click:row="editTemplate"
      @item-selected="handleSelectedRow"
      @toggle-select-all="handleSelectedRow"
    >
      <template v-slot:top>
        <v-toolbar flat height="70">
          <v-col cols="4" class="pl-0">
            <v-row justify="start" class="ml-1">
              <v-toolbar-title class="headline" :data-cy="title">
                <span> {{ title }} </span>
                <v-btn
                  v-if="canUseKnowledgeBaseBtn"
                  @click="handleHelp"
                  icon
                  color="primary"
                >
                  <v-icon>mdi-help-circle</v-icon>
                </v-btn>
              </v-toolbar-title>
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-4">
            <v-row justify="center">
              <v-col cols="6">
                <v-text-field
                  class="mx-4"
                  v-model="search"
                  :label="$t('components.lists.tasksTemplatesList.search')"
                  single-line
                  hide-details
                  color="primary"
                  @input="submitSearch"
                  @click:append-outer="submitSearch"
                  append-outer-icon="mdi-magnify"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row justify="end" class="mr-1">
              <v-btn
                color="primary"
                dark
                text
                data-cy="builderAddNewBtn"
                @click="newTemplate()"
                >{{ $t("components.lists.tasksTemplatesList.addNew") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-toolbar>
      </template>

      <template v-slot:item.name="{ item }">
        <div>
          {{ getTemplateName(item) }}
        </div>
      </template>

      <template v-slot:item.boat="{ item }">
        <div>
          {{ getBoatText(item) }}
        </div>
      </template>

      <template v-slot:item.type="{ item }">
        <div>
          {{ getTypeText(item) }}
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <div
          style="height: 40px"
          class="pt-2"
          onclick="event.stopPropagation()"
        >
          <v-icon class="mx-2 delete--hover" @click="removeTemplate(item)"
            >mdi-delete
          </v-icon>
          <v-icon class="mx-2 edit--hover" @click="createTask(item)"
            >{{ item.icon }}
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <v-pagination
      v-model="currentPage"
      :length="numberOfPages"
      :total-visible="7"
      color="primary"
    />
    <help-dialog
      :dialog="helpDialog"
      @close="closeHelpDialog"
      v-if="helpDialog.active"
    ></help-dialog>
  </div>
</template>

<script>
import HelpDialog from "@/components/dialogs/HelpDialog";
import constraints from "@/utils/constraints";

export default {
  props: {
    title: String,
    headers: Array,
    data: Array,
    sort: String,
    loading: Boolean,
    response: Object,
    createTaskTarget: {
      type: String,
      default: "tasksNew",
    },
  },

  components: {
    HelpDialog,
  },

  data: () => ({
    canUseKnowledgeBaseBtn: false,
    helpDialog: { location: null, active: false },
    search: "",
    page: 1,
    selected: [],
  }),
  created() {
    if (this.$route.query.page || this.$route.query.search) {
      this.search = this.$route.query.search;
      this.currentPage = Number(this.$route.query.page);
    }
    this.canUseKnowledgeBaseBtn = constraints.canUseKnowledgeBaseBtn("tasks");
  },

  computed: {
    numberOfPages() {
      if (!this.response) {
        return 0;
      }
      return parseInt(Math.ceil(this.response.count / 24));
    },
    currentPage: {
      get: function () {
        return this.page;
      },
      set: function (value) {
        this.page = value;
        this.$emit("reload", { search: this.search, page: value });
        this.$router.replace({
          name: this.$route.name,
          query: {
            page: this.page,
            search: this.search,
          },
        });
      },
    },
  },
  methods: {
    handleSelectedRow(item) {
      if (typeof item.item === "undefined") {
        this.data.forEach((element) => {
          element.icon = item.value
            ? "mdi-checkbox-multiple-marked-circle-outline"
            : "mdi-calendar-plus";
        });
        return;
      }

      let index = this.data.findIndex(
        (element) => element.uuid === item.item.uuid
      );
      this.data[index].icon = item.value
        ? "mdi-checkbox-multiple-marked-circle-outline"
        : "mdi-calendar-plus";
    },
    getBoatText(item) {
      if (item.checklists.length === 0) {
        return "";
      }
      return item.checklists[0].crm_boat === null
        ? this.$t("components.lists.tasksTemplatesList.any")
        : item.checklists[0].crm_boat.boat_name;
    },
    getTypeText(item) {
      if (item.checklists.length === 0) {
        return "";
      }
      return item.checklists[0].checklist_type === null
        ? this.$t("components.lists.tasksTemplatesList.team")
        : this.$t("components.lists.tasksTemplatesList.guest");
    },
    getTemplateName(item) {
      if (item.checklists.length === 0) {
        return "";
      }
      return item.checklists[0].name;
    },

    createTask(template) {
      if (this.selected.length >= 2) {
        this.$router.pushAsync({ name: this.createTaskTarget }).then(() => {
          this.$store.commit("SET_SERVICES", {
            from: "template",
            services: this.selected,
          });
        });
      } else {
        this.$router.pushAsync({ name: this.createTaskTarget }).then(() => {
          this.$store.commit("SET_SERVICES", {
            from: "template",
            services: [template],
          });
        });
      }
    },

    closeHelpDialog(event) {
      if (event === "close") {
        this.helpDialog.active = false;
      }
    },
    handleHelp(event) {
      this.helpDialog.active = true;
      this.helpDialog.location = "tasks";
    },

    submitSearch(event) {
      this.page = 1;
      this.$router.replace({
        name: this.$route.name,
        query: {
          page: this.page,
          search: this.search,
        },
      });
      this.$emit("reload", { search: this.search, page: this.page });
      return false;
    },
    newTemplate() {
      this.$emit("new", {});
    },
    editTemplate(item) {
      this.$emit("edit", item);
    },
    removeTemplate(item) {
      this.$emit("remove", item);
    },
  },
};
</script>

<style lang="scss">
.delete--hover {
  &:hover {
    color: red;
  }
}

.preview--hover {
  &:hover {
    color: --secondary;
  }
}

.edit--hover {
  &:hover {
    color: --primary;
  }
}
</style>
